/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentBlobDto } from '../models/Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentBlobDto';
import type { Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentDto } from '../models/Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AwardAcceptanceDocumentService {

    /**
     * @param awardId
     * @returns Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppAwardAcceptanceDocumentAwardAcceptanceDocumentsByAwardId(
        awardId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/award-acceptance-document/award-acceptance-documents-by-award-id/{awardId}',
            path: {
                'awardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param documentId
     * @returns Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppAwardAcceptanceDocumentDownloadAwardAcceptanceDocument(
        documentId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_AwardAcceptanceDocument_AwardAcceptanceDocumentBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/award-acceptance-document/download-award-acceptance-document/{documentId}',
            path: {
                'documentId': documentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
